import { canWorkspaceAction } from './permissions';

import type { Workspace } from '@web/types';

export const SETTINGS_SECTION_ORDER = [
  'team',
  'service-types',
  'deliverable-types',
  'workspace',
  'subscription',
  'terms-and-conditions',
] as const;

export type SettingsSectionKey = (typeof SETTINGS_SECTION_ORDER)[number];

export type SettingsSectionAccess = Record<SettingsSectionKey, boolean>;

export function buildSettingsSectionAccess(
  workspace: Workspace | null | undefined,
): SettingsSectionAccess {
  return {
    team:
      canWorkspaceAction(workspace, 'workspace_member_management', 'view') ||
      canWorkspaceAction(workspace, 'workspace_invite', 'view'),
    'service-types': canWorkspaceAction(
      workspace,
      'service_type_management',
      'view',
    ),
    'deliverable-types': canWorkspaceAction(
      workspace,
      'deliverable_type_management',
      'view',
    ),
    // * Workspace settings page is viewable by all members; field-level edits are gated separately.
    workspace: true,
    subscription:
      canWorkspaceAction(workspace, 'plan_management', 'view') ||
      canWorkspaceAction(workspace, 'manage_payment_information', 'view'),
    'terms-and-conditions': true,
  };
}
